export const SkeletonLoader = ({ height = 'h-11', width = 'w-full' }: { height?: string; width?: string }) => {
  return (
    <div
      className={`${width} ${height} bg-base-border rounded-md animate-pulse transition-opacity duration-500 ease-out`}
    />
  );
};
